import { ReactComponent as AddHomeIconSVG } from "./add-home-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconAddHome(props) {
  return <SvgIcon {...props} component={AddHomeIconSVG} viewBox="0 0 16 16" />;
}